import { useQuery } from "react-query";
import * as ajaxEndpoints from "../../../api/ajax-endpoints";
import { getDataWithDotNet } from "../../../newApis/dotNetApiMethods";
import { IResponse } from "../../../interfaces/response";

export interface IUserLockHistoryEntry {
  id: number;
  userId: string;
  reasonId: number;
  additionalInfo: string;
  operatorId: string;
  createdAt: string;
  userName: string;
  operatorName: string;
  reason: string;
  lockType: string;
}

export type TUserLockHistoryQuery = {
  ssoUserId: string;
};

const getUserLockHistory = async (
  query: TUserLockHistoryQuery,
): Promise<IResponse<IUserLockHistoryEntry[]>> => {
  const data = await getDataWithDotNet(
    `${ajaxEndpoints.USER_LOCK_HISTORY}?${new URLSearchParams(query).toString()}`,
  );
  return data;
};

export default function useGetUserLockHistory(
  query: TUserLockHistoryQuery | null,
) {
  return useQuery<IResponse<IUserLockHistoryEntry[]>, Error>(
    [query, "getUserLockHistory"],
    () => getUserLockHistory(query!),
    {
      enabled: !!query?.ssoUserId,
      refetchOnWindowFocus: false,
    },
  );
}
